/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
    TeamToJSONTyped,
} from './Team';

/**
 * 
 * @export
 * @interface GetTeamOutputBody
 */
export interface GetTeamOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof GetTeamOutputBody
     */
    readonly $schema?: string;
    /**
     * Team
     * @type {Team}
     * @memberof GetTeamOutputBody
     */
    team: Team;
}

/**
 * Check if a given object implements the GetTeamOutputBody interface.
 */
export function instanceOfGetTeamOutputBody(value: object): value is GetTeamOutputBody {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function GetTeamOutputBodyFromJSON(json: any): GetTeamOutputBody {
    return GetTeamOutputBodyFromJSONTyped(json, false);
}

export function GetTeamOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'team': TeamFromJSON(json['team']),
    };
}

export function GetTeamOutputBodyToJSON(json: any): GetTeamOutputBody {
    return GetTeamOutputBodyToJSONTyped(json, false);
}

export function GetTeamOutputBodyToJSONTyped(value?: Omit<GetTeamOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': TeamToJSON(value['team']),
    };
}

